import { Card, Divider, Grid, Typography, Box, Stack, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from 'components/Common/Button';
import AssistanceFooter from 'components/Common/AssistanceFooter';
import DetailItem from 'components/Staff/ItemDetail';
import Profile from 'components/Staff/Profile';
import { Link, useNavigate, useParams } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import Modal from 'components/Common/Modal';
import Routes from 'constants/routes';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { fetchParishDetails } from 'redux/slices/parishesAndOrganisations/parishDetailsSlice';
import MuiLoader from 'components/Common/Loader';
import { dateFormat, getAddress } from 'utils/helpers';

export default function OrganizationDetail() {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const params = useParams();
    const [resetPasswordModal, setResetPasswordModal] = useState(false);
    const [suspendEmployeeModal, setSuspendEmployeeModal] = useState(false);
    const { details, loading } = useSelector((state: RootState) => state.parish.parishDetails);
    const { companyId } = params || {};
    const { name, email, phone, createdDate, city, state, zip, username, address, companyCode } = details || {};

    useEffect(() => {
        companyId && dispatch(fetchParishDetails({ companyId }));
    }, [companyId, dispatch]);

    const handleSendMoney = () => {
        navigate(Routes.sendmoney.main, { state: { parish: { name, companyCode, companyId } } });
    };
    const handleSendInvoice = () => {
        navigate(Routes.sendinvoice.main, { state: { parish: { name, companyCode, companyId } } });
    };

    return (
        <Container maxWidth="xl">
            <Card
                sx={{
                    width: '100%',
                    p: '1rem',
                    my: 1,
                }}
            >
                <Stack m={'auto'} width={{ xs: '100%', md: '80%' }}>
                    <MuiLoader absolute loading={loading} />
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 2, marginTop: 10 }}>
                        <Typography sx={{ fontSize: 16, color: '#1F2937', fontWeight: 400 }} variant="h1">
                            Category
                        </Typography>
                        {/* <Stack direction="row" alignItems="center">
                    <Link to="/staff/details-edit">
                        <EditIcon style={{ cursor: 'pointer', marginTop: '6px' }} />
                    </Link>
                    <MoreVertIcon htmlColor="black" />
                </Stack> */}
                    </Box>
                    <Divider />
                    <Profile my={6} user={details} />
                    <Grid sx={{ my: 6 }} container spacing={2}>
                        {/* Left Container */}
                        <Grid item xs={12} md={6}>
                            <DetailItem label="Entity name" value={name} />
                            <DetailItem label="Email/user name" value={email || username} />
                            {/* <DetailItem label="Category" value="Director of Volunteers" />
                    <DetailItem label="Date added" value={dateFormat(createdDate)} /> */}
                            <DetailItem label="Phone" value={phone} />
                        </Grid>

                        {/* Right Container */}
                        <Grid item xs={12} md={6}>
                            <DetailItem label="Address" value={getAddress(details) ? getAddress(details) : address} />
                            {/* <DetailItem label="City" value={city} />
                    <DetailItem label="State" value={state} />
                    <DetailItem label="Zip" value={zip} /> */}
                        </Grid>
                    </Grid>
                    {/* style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 24, marginBottom: '6rem', marginTop: '6rem' }} */}
                    <Stack direction={'row'} spacing={2}>
                        <Button width="100%" onClick={handleSendMoney} title="Send Money" />
                        <Button width="100%" onClick={handleSendInvoice} title="Send Invoice" />
                    </Stack>

                    {/* Reset Password Modal */}
                    <Modal isOpen={resetPasswordModal} onClose={() => setResetPasswordModal(false)}>
                        <>
                            <Typography sx={{ fontSize: 18, my: 2 }}>
                                A link to change password has been sent to the email address listed for this user. <br />
                            </Typography>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                                <Button onClick={() => setResetPasswordModal(false)} width={152} title="Done" />
                            </div>
                        </>
                    </Modal>
                    {/* Suspend Employee Modal */}
                    <Modal isOpen={suspendEmployeeModal} onClose={() => setSuspendEmployeeModal(false)}>
                        <>
                            <Typography sx={{ fontSize: 18, my: 2 }}>
                                Once you disable an employee they will nolonger be able to log into the portal. You will be able to
                                reactivate the employee through the “Inactive” employee section. Are you sure you would like to disable this
                                employee? <br />
                            </Typography>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                                <Button onClick={() => setSuspendEmployeeModal(false)} width={'45%'} title="Cancel" />
                                <Button onClick={() => setSuspendEmployeeModal(false)} width={'45%'} title="Confirm" />
                            </div>
                        </>
                    </Modal>

                    <AssistanceFooter />
                </Stack>
            </Card>
        </Container>
    );
}
